import React, {FC} from 'react';

import {RendererOf} from '../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {AnalyticsMetricError} from '../../../../../models/api/analyticsMetricsModel';
import {EmptyState} from '../emptyState';
import {analyticsErrorImage, computeMetricErrorTitle} from './errorHelpers';

/*
 * Types.
 */

export type ErrorStateRenderer = RendererOf<{
  metricError: AnalyticsMetricError;
  width?: number;
  height?: number;
}>;

/*
 * Props.
 */

interface MetricErrorStateProps {
  error: AnalyticsMetricError;
  width?: number;
  height?: number;
}

/*
 * Component.
 */

export const MetricErrorState: FC<MetricErrorStateProps> = ({error, width, height}) => {
  const {title, subtitle} = computeMetricErrorTitle(error);

  return (
    <EmptyState title={title} subtitle={subtitle} width={width} height={height} image={analyticsErrorImage} />
  );
};

/*
 * Helpers.
 */

export const defaultErrorStateRenderer: ErrorStateRenderer = ({metricError, height, width}) => (
  <MetricErrorState error={metricError} height={height} width={width} />
);
